import React, { useState, useEffect } from "react";
import axiosInstance from "../../utils/axiosInstance";
import { useNavigate, Link } from "react-router-dom";
import { runSecurityTests } from '../../utils/securityTest';
import './Login.css';

const BACKEND_PORT = process.env.REACT_APP_API_BASE_URL;

export default function Register() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [registrationError, setRegistrationError] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Trim inputs
        const trimmedName = name.trim();
        const trimmedEmail = email.trim();
        const trimmedPassword = password.trim();

        // Run security tests
        const securityResults = runSecurityTests(trimmedName + trimmedEmail + trimmedPassword);
        if (Object.values(securityResults).some(result => result)) {
            setRegistrationError("Invalid input detected");
            return;
        }

        // Basic validation
        if (!trimmedName || !trimmedEmail || !trimmedPassword) {
            setRegistrationError("Please fill in all fields");
            return;
        }

        // Email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(trimmedEmail)) {
            setRegistrationError("Please enter a valid email address");
            return;
        }

        // Password strength validation
        if (trimmedPassword.length < 8) {
            setRegistrationError("Password must be at least 8 characters long");
            return;
        }

        try {
            const response = await axiosInstance.post('/users', { 
                name: trimmedName, 
                email: trimmedEmail, 
                password: trimmedPassword 
            });
            if (response.status === 200 || response.status === 201) {
                navigate('/');  // Redirect to home after successful registration
            } else {
                setRegistrationError("Registration failed. Please check your details.");
            }
        } catch (err) {
            if (err.response) {
                // If the error contains a message, display that. Otherwise, show a default error message.
                setRegistrationError(err.response.data.message || "An error occurred. Please try again.");
            } else {
                setRegistrationError("An error occurred. Please try again.");
            }
        }
    };
    

    return (
        <>
        <div className="login-container">
            <div className="login-box">
                <h1 className="login-title">New Account</h1>
                <form onSubmit={handleSubmit} className="login-form">
                    <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Name" className="login-input" />
                    <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="login-input" />
                    <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="login-input" />
                    <div>Already have an account? <Link to={`/Login`}>Login here.</Link></div>
                    <button type="submit" className="new-account-button">Create Account</button>
                </form>
                {registrationError && <div className="login-error">{registrationError}</div>}
            </div>
        </div>
        <div style={{ 
        aspectRatio: "960/110", 
        backgroundImage: "url('/greyToPinkLogin.png')",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
    }}></div>
  </>
    );
}
